import { Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { openModuleLink } from '../../utils/open-module-link';

@Component({
  selector: 'app-module-card',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './module-card.component.html',
  styleUrl: './module-card.component.scss'
})
export class ModuleCardComponent implements OnChanges {
  @Input() title: string = '';
  @Input() text: string | null = '';
  @Input() url: string | null = null;
  @Input() code: string | null = null;
  @Input() isMaintenance: boolean = false;
  @Input() isOverflow: boolean = false;

  imageLoadFailed = false;

  private readonly apiService = inject(ApiService);
  constructor(private router: Router) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['code']) {
      this.imageLoadFailed = false;
    }
  }

  onModuleImageError(): void {
    this.imageLoadFailed = true;
  }

  async onSelectModule(): Promise<void> {
    if (!this.url || !this.code) {
      return;
    }

    await openModuleLink({
      code: this.code,
      title: this.title,
      router: this.router,
      apiService: this.apiService
    });
  }
}
